<template>
  <v-card-text>
    <slot />
  </v-card-text>
</template>

<script>
export default { name: 'JexyCardText' }
</script>
